/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import cn from "classnames";
import { Button, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SVGIcons } from "cms/icons/svg-icons";

const ReuseComponentButton = (props) => {
    
    const { handleOpen, isDisabled, size } = props;
    const { t } = useTranslation();
    const onClickButton = () => {
        handleOpen();
    };
    const containerClass = cn("reuse-component-button", {
        disabled: isDisabled
    });

    return (
        <div className={containerClass}>
            <Stack direction='column' justifyContent='flex-start' mb={1}>
                <Stack direction='row' justifyContent='center' mt={1}>
                    <Button
                        className='button-accent-outlined'
                        disabled={isDisabled}
                        variant='outlined'
                        color='accent'
                        size={size || "large"}
                        onClick={onClickButton}
                        startIcon={<SVGIcons.common.Recycle />}
                    >
                        {t("Components.reuseComponent")}
                    </Button>
                </Stack>
            </Stack>
        </div>
    );
};

export { ReuseComponentButton };
